export const settings = {
  title: "Configurações",
  subtitle: "Personalize sua experiência com o Araria",
  sections: {
    site: {
      title: "Configurações do Site",
      subtitle: "Personalize a aparência e o comportamento do Araria",
    },
    api: {
      title: "Configurações de API",
      subtitle: "Gerencie suas chaves de API e integrações",
      araria: {
        title: "Chave API Araria",
        description: "Sua chave única para acessar os serviços Araria",
        generate: "Gerar Chave",
        regenerate: "Regerar Chave",
        copy: "Copiar Chave",
        allowedDomains: "Domínios Permitidos",
        allowedDomainsPlaceholder:
          "Digite os domínios permitidos (separados por vírgula)",
      },
      providers: {
        title: "Provedores de IA",
        description:
          "Configure suas chaves de API para diferentes provedores de IA",
        openai: "Chave API OpenAI",
        anthropic: "Chave API Anthropic",
        google: "Chave API Google AI",
        placeholder: "Digite sua chave de API",
        save: "Salvar",
        saved: "Chave Salva",
        delete: "Remover Chave",
        notice:
          "As chaves de API são armazenadas localmente no seu dispositivo e não são compartilhadas com nossa equipe ou terceiros.",
      },
    },
    plan: {
      title: "Plano de Assinatura",
      subtitle: "Gerencie sua assinatura atual",
      current: "Plano Atual",
      upgrade: "Atualizar Plano",
      downgrade: "Reduzir Plano",
      change: "Mudar Plano",
    },
  },
  theme: "Tema",
  language: "Idioma",
  darkMode: "Modo Escuro",
  lightMode: "Modo Claro",
  english: "English",
  portuguese: "Português",
  spanish: "Español",
};
